import { FormikProps } from "formik";
import React, { useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useApiClient, apiClient } from "../../../../shared/customHooks";
import { eventEmitter } from "../../../../shared/event";
import { ChecklistEmailStatus } from "../../../../shared/formObjects/application/applicationChecklistForm";
import { ModalRef, Modal } from "../../../modal/modal";
import { ToastInfo } from "../../../toaster/toaster";
import { useApplicationContext } from "../../context/applicationContext";
import { applicationChecklistFormLegacy } from "../../../../shared/formObjects/application/legacy/applicationChecklistFormLegacy";
import BaseApplicationComponent from "../../../../shared/baseComponent/baseWrappers/BaseApplicationComponent";

function ApplicationChecklistComponentLegacy({ disabled, data, index }: any) {
  const { fetchData, postData, putData } = useApiClient(`ApplicationChecklistLegacy`);
  const [rest, setRest] = useState<any>({ checklistsLegacy: [] });
  const { id } = useApplicationContext();

  const [emailDetails, setEmailDetails] = useState<any[]>([]);
  const [currentData, setCurrentData] = useState<any>(null);

  const navigate = useNavigate();

  const api: apiClient = useMemo(
    () => ({
      fetchData: async (route?: string, params?: any) =>
        await fetchData(route, params).then((res) => {
          setRest(res.data);
          res.data = res.data.checklistsLegacy[0];
          return res;
        }),
      putData: async (formData: any, route?: string) => {
        const restData = { ...rest };
        restData.checklistsLegacy[0] = formData;
        return await putData(restData, route);
      },
      postData: async (formData: any, route?: string) => {
        const restData = { ...rest };
        restData.checklistsLegacy[0] = formData;
        return await postData(restData, route);
      },
    }),
    [rest]
  );
  const modalRef = useRef<ModalRef | null>(null);

  function triggerModal(newData: any) {
    setCurrentData(newData);
    f?.validateForm().then((value) => {
      if (JSON.stringify(value) === "{}") {
        postData(newData, `preview/${id}`).then((res) => {
          setEmailDetails(res.data);
          modalRef.current?.toggle();
        });
      } else {
        f.setTouched(touchAllFields(value));
      }
    });
  }

  function touchAllFields(obj: any): any {
    if (typeof obj !== "object" || obj === null) {
      return true;
    }
    const touched: any = {};
    for (const key of Object.keys(obj)) {
      touched[key] = touchAllFields(obj[key]);
    }
    return touched;
  }

  const [f, setFormik] = useState<FormikProps<any> | null>(null);
  const [newForm, setNewForm] = useState(true);

  function getInitalValues(initialData: any, formik: FormikProps<any>) {
    setNewForm(initialData.emailStatus == null || initialData.emailStatus === ChecklistEmailStatus.NoEmailSent);
    setFormik(formik);
    const today = new Date();
    const defaultFutureDate = new Date();
    defaultFutureDate.setDate(
      today.getDate() + (initialData.emailStatus == null || initialData.emailStatus === ChecklistEmailStatus.NoEmailSent ? 14 : 7)
    );

    if (
      (initialData.emailStatus == null || initialData.emailStatus === ChecklistEmailStatus.NoEmailSent) &&
      !initialData?.emailGroup?.firstEmailDueDate
    ) {
      formik.setFieldValue("emailGroup.firstEmailDueDate", defaultFutureDate);
    } else if (initialData.emailStatus === ChecklistEmailStatus.InitialEmail && !initialData?.emailGroup?.firstReminderEmailDueDate) {
      formik.setFieldValue("emailGroup.firstReminderEmailDueDate", defaultFutureDate);
    } else if (initialData.emailStatus === ChecklistEmailStatus.FirstReminder && !initialData?.emailGroup?.finalReminderEmailDueDate) {
      formik.setFieldValue("emailGroup.finalReminderEmailDueDate", defaultFutureDate);
    }
  }

  function confirmEmail() {
    postData(currentData, `SubmitEmailChecklistLegacy/${id}`).then(() => {
      const data: ToastInfo = { title: "Success", message: "Email Submission Successful!", severity: "success" };
      eventEmitter.emit("tstr", data);
      const targetPath = `/applications/ApplicationBaseLegacy/${id}`;
      navigate(targetPath);
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  function createNewChecklist() {
    postData(null, `addChecklist/${id}`).then(() => {
      const data: ToastInfo = { title: "Success", message: "Checklist Created!", severity: "success" };
      eventEmitter.emit("tstr", data);
      navigate(`/applications/ApplicationBaseLegacy/${id}`);
    });
  }

  const form = useMemo(() => {
    return applicationChecklistFormLegacy(triggerModal);
  }, [modalRef.current]);

  return (
    <>
      {" "}
      <BaseApplicationComponent
        formBody={form}
        headerLabel="Application Checklist"
        editPath="applicationchecklist"
        submitBtnTitle={newForm ? "Save" : "Create New Checklist"}
        customSubmit={newForm ? undefined : createNewChecklist}
        apiClient={api}
        disabled={disabled}
        data={data}
        showEdit={index == 0}
        isNavHidden={index > 0}
        getInitialValues={getInitalValues}
        id={id}
      />
      <Modal ref={modalRef} confirmAction={confirmEmail} headerLabel="Submit & Send Email Confirmation" confirmLabel="Submit & Send Email">
        <div className="email-table">
          <p className="text-left">
            If you submit this form, the system will update the status of this application and send an email to the kindergarten requesting the
            following items on the checklist are addressed
          </p>
          <div style={{ textAlign: "left", padding: "1em" }}>
            <ul className="pl-0">
              {emailDetails.map((x: { message: string; facilitatorDescription: string }, index: number) => (
                <li key={index} className="list-none">
                  <table style={{ tableLayout: "fixed", width: "100%", padding: "0px" }}>
                    <tr className="border-bottom-1">
                      <td valign="top" className="checklist">
                        {x.message}
                      </td>
                      <td valign="top">{x.facilitatorDescription}</td>
                    </tr>
                  </table>
                </li>
              ))}
            </ul>
            <p style={{ whiteSpace: "pre-line" }}>{currentData?.summary}</p>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default ApplicationChecklistComponentLegacy;
